import { useRef, useState, useEffect } from "react"

const useNavHeight = () => {
  const navRef = useRef(null) // To reference the nav element
  const [navHeight, setNavHeight] = useState(0) // To store the height

  useEffect(() => {
    // Function to calculate the nav height
    const calculateNavHeight = () => {
      if (navRef.current) {
        setNavHeight(navRef.current.offsetHeight)
      }
    }

    // Calculate height initially
    calculateNavHeight()

    // Recalculate on window resize
    const handleResize = () => calculateNavHeight()
    window.addEventListener("resize", handleResize)

    // Cleanup the event listener on unmount
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  // Return both the ref and the calculated height
  return { navRef, navHeight }
}

export default useNavHeight
